import {
	generateCaptchaToken as _generateCaptchaToken,
	generateCaptchaTokenResult as _generateCaptchaTokenResult,
} from '@worldcoo/ui/lib/captcha';
import { getRuntimeRecaptchaSiteKey } from './shared';

/** @deprecated Use `generateCaptchaTokenResult` instead, as it provides a result with error handling */
export function generateCaptchaToken(): Promise<string> {
	return _generateCaptchaToken(getRuntimeRecaptchaSiteKey());
}

export function generateCaptchaTokenResult() {
	return _generateCaptchaTokenResult(getRuntimeRecaptchaSiteKey());
}
